import React, { useState, useEffect } from 'react';
import { object, func, bool } from 'prop-types';
import { Tab, Tabs } from '../../common/TabCustom';
import { TableCustom, MessageModal, InputCuenta, Loading, InputLista } from '../../common';
import { ALERT_TYPE, OPERATION_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { APIS } from '../../../config/apis';
import { ServerRequest } from '../../../utils/apiweb';
import { useLista } from '../../hooks/useLista';
import { useEntidad } from '../../hooks/useEntidad';
import { getFormatNumber } from '../../../utils/convert';
import { isNull, isValidNumber } from '../../../utils/validator';
import { SECCION_TYPE } from '../../../consts/seccionType';

const EmisionEjecucionCuentasGrid = (props) => {

  const resultInit = {
    cuenta: {
      id: 0,
      numeroCuenta: '',
      numeroWeb: '',
      idEstadoCuenta: 0,
      idTipoTributo: 0,
      idTributo: 0,
      fechaAlta: null,
      fechaBaja: null
    },
    emisionEjecucionCuenta: {
      id: 0,
      idEmisionEjecucion: 0,
      idCuenta: 0,
      idEstadoEmisionEjecucionCuenta: 0,
      numeroBloque: 0,
      numero: 0,
      observacion: '',
      idControlador: 0,
      emisionCalculosResultado: []
    },
    emisionCalculos: []
  }

  //hooks
  const [state, setState] = useState({
      idCuenta: 0,
      idTipoTributo: 0,
      emisionEjecucion: null,
      emisionDefinicion: {
        procesaRubros: false,
        idBoletaDefinicion: null
      },
      disabled: false,
      showMessage: false,
      loading: false,
      tabActive: "conceptos"
  });
  const [result, setResult] = useState(resultInit);

  const [ formValues, formHandle, , formSet] = useForm({
    numero: 0,
    idCuenta: 0,
    idEstadoEmisionEjecucionCuenta: 262
  });

  const mount = () => {
    if (props.data.emisionEjecucion) {
      setState(prevState => {
        return {...prevState,
          idCuenta: props.data.idCuenta,
          idTipoTributo: props.data.idTipoTributo,
          emisionEjecucion: props.data.emisionEjecucion,
          emisionDefinicion: props.data.emisionDefinicion,
        };
      });
    }
    CleanEmisionEjecucionCuenta();
  }
  useEffect(mount, [props.data.emisionEjecucion]);

  useEffect(() => {
    if (state.idCuenta > 0) {
      FindEmisionEjecucionCuenta(state.emisionEjecucion.id, null,null, 0, state.idCuenta);
    }
  }, [state.idCuenta]);

  const [, getRowLista] = useLista({
    listas: ['TipoEmisionCalculo', 'TipoSeccion'],
    onLoaded: (listas, isSuccess, error) => {
        if (!isSuccess) {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
        }
    },
    memo: {
      key: 'TipoEmisionCalculo_TipoSeccion',
      timeout: 0
    }
  });

  const [, getRowEntidad] = useEntidad({
    entidades: ['Tasa', 'SubTasa', 'Rubro', 'TipoMovimiento', 'BoletaDefinicionSeccion'],
    onLoaded: (entidades, isSuccess, error) => {
      if (!isSuccess) {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: {
      key: 'Tasa_SubTasa_Rubro_TipoMovimiento_BoletaDefinicionSeccion',
      timeout: 0
    }
  });

  const getDescAplicacion = (row) => {
    return (row) ?
      (row.aplicaRecibo && row.aplicaBoleta) ? 'Vep/Boleta' :
      (row.aplicaRecibo && !row.aplicaBoleta) ? 'Vep' :
      (!row.aplicaRecibo && row.aplicaBoleta) ? 'Boleta' : ''
      : '';
  }

  const tableColumnsCalculos = [
    { Header: 'Cuota', accessor: 'cuota', width: '15%', ellipsis: false},
    { Header: 'Rubro', accessor: 'rubro', width: '15%', id: 'rubro', ellipsis: false},
    { Header: 'Tipo', accessor: 'tipo', width: '15%', disableSortBy: true, ellipsis: false},
    { Header: 'Cálculo', accessor: 'calculo', width: '35%', ellipsis: false},
    { Header: 'Valor', Cell: (data) => isValidNumber(data.value) ? getFormatNumber(data.value, 2) : data.value, accessor: 'valor', width: '20%', alignCell: 'right', disableGlobalFilter: true, disableSortBy: true, ellipsis: false},
  ];
  const tableColumnsBoletaSecciones = [
    { Header: 'Item', accessor: 'item', width: '25%', disableSortBy: true },
    { Header: 'Período', accessor: 'periodo', width: '7%', disableSortBy: true, ellipsis: false},
    { Header: 'Cuota', accessor: 'cuota', width: '5%', ellipsis: false},
    { Header: 'Rubro', accessor: 'rubro', width: '8%', id: 'rubro', ellipsis: false},
    { Header: 'Tipo sección', accessor: 'tipoSeccion', width: '10%', disableSortBy: false },
    { Header: 'Contenido', Cell: (props) => {
      const row = props.row.original;
      if (row.idTipoSeccion === SECCION_TYPE.TEXTO) {
        return row.valorSeccion;
      }
      else {
        return `[${row.tipoSeccion}]`;
      }
    }, id: 'recibo', accessor: 'valorSeccion', width: '45%', ellipsis: true}
  ];
  const tableColumnsConceptos = [
    { Header: 'VEP', Cell: (props) => {
        if (result && result.emisionEjecucionCuenta) {
          const row = props.row.original;
          const emisionEjecucionCuentaCuota = result.emisionEjecucionCuenta.emisionEjecucionCuentaCuotas.find(f => f.idEmisionEjecucionCuota === row.idEmisionEjecucionCuota);
          return emisionEjecucionCuentaCuota ? emisionEjecucionCuentaCuota.numeroRecibo : '';
        }
        else {
          return '';
        }
      }, id: 'recibo', accessor: 'id', width: '7%', ellipsis: false},
    { Header: 'Item', accessor: 'item', width: '16%', disableSortBy: true },
    { Header: 'Movimiento', accessor: 'tipoMovimiento', width: '8%', disableSortBy: true },
    { Header: 'Período', accessor: 'periodo', width: '6%', disableSortBy: true, ellipsis: false},
    { Header: 'Cuota', accessor: 'cuota', width: '5%', ellipsis: false},
    { Header: 'Rubro', accessor: 'rubro', width: '8%', id: 'rubro', ellipsis: false},
    { Header: 'Tasa', accessor: 'tasa', width: '6%', disableSortBy: true, ellipsis: false},
    { Header: 'Sub tasa', accessor: 'subTasa', width: '13%', disableSortBy: true },
    { Header: 'Importe', Cell: (data) => isValidNumber(data.value) ? getFormatNumber(data.value, 2) : data.value, accessor: 'valorImporteTotal', width: '10%', alignCell: 'right', disableGlobalFilter: true, disableSortBy: true, ellipsis: false},
    { Header: 'A cancelar', Cell: (data) => isValidNumber(data.value) ? getFormatNumber(data.value, 2) : data.value, accessor: 'valorImporteNeto', width: '10%', alignCell: 'right', disableGlobalFilter: true, disableSortBy: true, ellipsis: false},
    { Header: 'Vto.', Cell: (props) => props.value === 0 ? "1-2" : props.value, accessor: 'vencimiento', width: '4%', disableSortBy: true, ellipsis: false},
    { Header: 'Aplica', Cell: (props) => getDescAplicacion(props.row.original), id: 'aplicacion', accessor: 'id', width: '5%', disableSortBy: true }
  ];
  const tableColumnsCuentasCorrientes = [
    { Header: 'Item', accessor: 'item', width: '26%', disableSortBy: true },
    { Header: 'Movimiento', accessor: 'tipoMovimiento', width: '8%', disableSortBy: true },
    { Header: 'Período', accessor: 'periodo', width: '7%', ellipsis: false},
    { Header: 'Cuota', accessor: 'cuota', width: '5%', ellipsis: false},
    { Header: 'Rubro', accessor: 'rubro', width: '8%', id: 'rubro', ellipsis: false},
    { Header: 'Tasa', accessor: 'tasa', width: '7%', disableSortBy: true, ellipsis: false},
    { Header: 'Sub tasa', accessor: 'subTasa', width: '13%', disableSortBy: true },
    { Header: 'Debe', Cell: (data) => isValidNumber(data.value) ? getFormatNumber(data.value, 2) : data.value, accessor: 'valorDebe', width: '10%', alignCell: 'right', disableGlobalFilter: true, disableSortBy: true, ellipsis: false},
    { Header: 'Haber', Cell: (data) => isValidNumber(data.value) ? getFormatNumber(data.value, 2) : data.value, accessor: 'valorHaber', width: '10%', alignCell: 'right', disableGlobalFilter: true, disableSortBy: true, ellipsis: false},
    { Header: 'Vto.', Cell: (props) => props.value === 0 ? "1-2" : props.value, accessor: 'vencimiento', width: '4%', disableSortBy: true, ellipsis: false}
  ];
  const tableColumnsImputacionesContables = [
    { Header: 'Item', accessor: 'item', width: '30%', disableSortBy: true },
    { Header: 'Período', accessor: 'periodo', width: '7%', ellipsis: false},
    { Header: 'Cuota', accessor: 'cuota', width: '5%', ellipsis: false},
    { Header: 'Rubro', accessor: 'rubro', width: '8%', id: 'rubro', ellipsis: false},
    { Header: 'Tasa', accessor: 'tasa', width: '7%', disableSortBy: true, ellipsis: false},
    { Header: 'Sub tasa', accessor: 'subTasa', width: '13%', disableSortBy: true },
    { Header: 'Tasa %', accessor: 'tasaPorcentaje', width: '7%', disableSortBy: true, ellipsis: false},
    { Header: 'Sub tasa %', accessor: 'subTasaPorcentaje', width: '13%', disableSortBy: true, ellipsis: false},
    { Header: 'Porcentaje', Cell: (data) => isValidNumber(data.value) ? getFormatNumber(data.value, 2) : data.value, accessor: 'valorPorcentaje', alignCell: 'right', width: '10%', disableGlobalFilter: true, disableSortBy: true, ellipsis: false}
  ]; 

  //handles
  const handleClickEmisionEjecucionCuentaPrevious = () => {
    FindEmisionEjecucionCuenta(state.emisionEjecucion.id, formValues.idEstadoEmisionEjecucionCuenta, formValues.numero, OPERATION_TYPE.lt, null);
  }
  const handleClickEmisionEjecucionCuentaNext = () => {
    FindEmisionEjecucionCuenta(state.emisionEjecucion.id, formValues.idEstadoEmisionEjecucionCuenta, formValues.numero, OPERATION_TYPE.gt, null);
  }

  //callbacks
  const callbackNoSuccess = (response) => {
    response.json()
    .then((error) => {
        const message = error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    })
    .catch((error) => {
        const message = 'Error procesando respuesta: ' + error;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    });
  }
  const callbackError = (error) => {
      const message = 'Error procesando solicitud: ' + error.message;
      ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
      setState(prevState => {
          return {...prevState, loading: false};
      });
  }
  const callbackSuccessFindEmisionEjecucionCuenta = (response) => {
      response.json()
      .then((data) => {

        //if (data.emisionEjecucionCuenta.numero > 0 && data.emisionEjecucionCuenta.idEstadoEmisionEjecucionCuenta === EMISION_EJECUCION_CUENTA_STATE.FINALIZADA) {
        if (data.emisionEjecucionCuenta.id > 0) {

          const sortResult = (a, b) => {
            if (a.ordenCuota < b.ordenCuota) return -1;
            else if (a.ordenCuota > b.ordenCuota) return 1;
            else if (a.ordenCuota === b.ordenCuota && a.orden < b.orden) return -1;
            else if (a.ordenCuota === b.ordenCuota && a.orden > b.orden) return 1;
            else return 0;
          };

          //calculos ordenados por el orden de la cuota y luego el orden de calculos
          data.emisionEjecucionCuenta.emisionCalculosResultado.forEach((row) => {
            const emisionEjecucionCuota = data.emisionEjecucionCuotas.find(f => f.id === row.idEmisionEjecucionCuota);
            const emisionCalculo = data.emisionCalculos.find(f => f.id === row.idEmisionCalculo);
            const tipoEmisionCalculo = getRowLista('TipoEmisionCalculo', emisionCalculo.idTipoEmisionCalculo);
            const rubro = (state.emisionDefinicion.procesaRubros) ? getRowEntidad('Rubro', row.idRubro) : {codigo: ''};
            row.cuota = emisionEjecucionCuota.cuota;
            row.rubro = rubro.codigo;
            row.ordenCuota = emisionEjecucionCuota.orden;
            row.calculo = emisionCalculo.nombre;
            row.orden = emisionCalculo.orden;
            row.tipo = tipoEmisionCalculo.nombre;
          });
          data.emisionEjecucionCuenta.emisionCalculosResultado = data.emisionEjecucionCuenta.emisionCalculosResultado.sort(sortResult);

          //secciones de boleta ordenadas por el orden de la cuota y luego el orden de las secciones
          data.emisionEjecucionCuenta.emisionBoletaSeccionesResultado.forEach((row) => {
            const emisionEjecucionCuota = data.emisionEjecucionCuotas.find(f => f.id === row.idEmisionEjecucionCuota);
            const emisionBoletaSeccion = data.emisionBoletaSecciones.find(f => f.id === row.idEmisionBoletaSeccion);
            const boletaDefinicionSeccion = getRowEntidad('BoletaDefinicionSeccion', emisionBoletaSeccion.idBoletaDefinicionSeccion);
            const tipoSeccion = getRowLista('TipoSeccion', boletaDefinicionSeccion.idTipoSeccion);
            const rubro = (state.emisionDefinicion.procesaRubros) ? getRowEntidad('Rubro', row.idRubro) : {codigo: ''};
            row.idTipoSeccion = tipoSeccion.id;
            row.tipoSeccion = tipoSeccion.nombre;
            row.cuota = emisionEjecucionCuota.cuota;
            row.rubro = rubro.codigo;
            row.ordenCuota = emisionEjecucionCuota.orden;
            row.item = emisionBoletaSeccion.descripcion;
            row.orden = emisionBoletaSeccion.orden;
            row.periodo = state.emisionEjecucion.periodo;
          });
          data.emisionEjecucionCuenta.emisionBoletaSeccionesResultado = data.emisionEjecucionCuenta.emisionBoletaSeccionesResultado.sort(sortResult);

          //conceptos ordenados por el orden de la cuota y luego el orden de conceptos
          data.emisionEjecucionCuenta.emisionConceptosResultado.forEach((row) => {
            const emisionEjecucionCuota = data.emisionEjecucionCuotas.find(f => f.id === row.idEmisionEjecucionCuota);
            const emisionConcepto = data.emisionConceptos.find(f => f.id === row.idEmisionConcepto);
            const tipoMovimiento = getRowEntidad('TipoMovimiento', emisionConcepto.idTipoMovimiento);
            const tasa = getRowEntidad('Tasa', emisionConcepto.idTasa);
            const subTasa = getRowEntidad('SubTasa', emisionConcepto.idSubTasa);
            const rubro = (state.emisionDefinicion.procesaRubros) ? getRowEntidad('Rubro', row.idRubro) : {codigo: ''};
            row.cuota = emisionEjecucionCuota.cuota;
            row.rubro = rubro.codigo;
            row.ordenCuota = emisionEjecucionCuota.orden;
            row.item = emisionConcepto.descripcion;
            row.orden = emisionConcepto.orden;
            row.periodo = state.emisionEjecucion.periodo;
            row.vencimiento = emisionConcepto.vencimiento;
            row.aplicaBoleta = emisionConcepto.aplicaBoleta;
            row.aplicaRecibo = emisionConcepto.aplicaRecibo;
            row.tasa = tasa.codigo;
            row.subTasa = `${subTasa.codigo} - ${subTasa.descripcion}`;
            row.tipoMovimiento = tipoMovimiento.nombre;
          });
          data.emisionEjecucionCuenta.emisionConceptosResultado = data.emisionEjecucionCuenta.emisionConceptosResultado.sort(sortResult);

          //cta cte ordenados por el orden de la cuota y luego el orden de cta cte
          data.emisionEjecucionCuenta.emisionCuentasCorrientesResultado.forEach((row) => {
            const emisionEjecucionCuota = data.emisionEjecucionCuotas.find(f => f.id === row.idEmisionEjecucionCuota);
            const emisionCuentaCorriente = data.emisionCuentasCorrientes.find(f => f.id === row.idEmisionCuentaCorriente);
            const tipoMovimiento = getRowEntidad('TipoMovimiento', emisionCuentaCorriente.idTipoMovimiento);
            const tasa = getRowEntidad('Tasa', emisionCuentaCorriente.idTasa);
            const subTasa = getRowEntidad('SubTasa', emisionCuentaCorriente.idSubTasa);
            const rubro = (state.emisionDefinicion.procesaRubros) ? getRowEntidad('Rubro', row.idRubro) : {codigo: ''};
            row.cuota = emisionEjecucionCuota.cuota;
            row.rubro = rubro.codigo;
            row.ordenCuota = emisionEjecucionCuota.orden;
            row.item = emisionCuentaCorriente.descripcion;
            row.orden = emisionCuentaCorriente.orden;
            row.periodo = state.emisionEjecucion.periodo;
            row.vencimiento = emisionCuentaCorriente.vencimiento;
            row.tasa = tasa.codigo;
            row.subTasa = `${subTasa.codigo} - ${subTasa.descripcion}`;
            row.tipoMovimiento = tipoMovimiento.nombre;
          });
          data.emisionEjecucionCuenta.emisionCuentasCorrientesResultado = data.emisionEjecucionCuenta.emisionCuentasCorrientesResultado.sort(sortResult);

          //imp cont ordenados por el orden de la cuota y luego el orden de imp cont
          data.emisionEjecucionCuenta.emisionImputacionesContablesResultado.forEach((row) => {
            const emisionEjecucionCuota = data.emisionEjecucionCuotas.find(f => f.id === row.idEmisionEjecucionCuota);
            const emisionImputacionContable = data.emisionImputacionesContables.find(f => f.id === row.idEmisionImputacionContable);
            const tasa = getRowEntidad('Tasa', emisionImputacionContable.idTasa);
            const subTasa = getRowEntidad('SubTasa', emisionImputacionContable.idSubTasa);
            const tasaPorcentaje = getRowEntidad('Tasa', emisionImputacionContable.idTasaPorcentaje);
            const subTasaPorcentaje = getRowEntidad('SubTasa', emisionImputacionContable.idSubTasaPorcentaje);
            const rubro = (state.emisionDefinicion.procesaRubros) ? getRowEntidad('Rubro', row.idRubro) : {codigo: ''};
            row.cuota = emisionEjecucionCuota.cuota;
            row.rubro = rubro.codigo;
            row.ordenCuota = emisionEjecucionCuota.orden;
            row.item = emisionImputacionContable.descripcion;
            row.orden = emisionImputacionContable.orden;
            row.periodo = state.emisionEjecucion.periodo;
            row.tasa = tasa.codigo;
            row.subTasa = `${subTasa.codigo} - ${subTasa.descripcion}`;
            row.tasaPorcentaje = tasaPorcentaje.codigo;
            row.subTasaPorcentaje = `${subTasaPorcentaje.codigo} - ${subTasaPorcentaje.descripcion}`;
          });
          data.emisionEjecucionCuenta.emisionImputacionesContablesResultado = data.emisionEjecucionCuenta.emisionImputacionesContablesResultado.sort(sortResult);

          setResult(data);
          formSet({
            numero: data.emisionEjecucionCuenta.id,
            idCuenta: data.cuenta.id,
            idEstadoEmisionEjecucionCuenta: data.emisionEjecucionCuenta.idEstadoEmisionEjecucionCuenta
          });
          setState(prevState => {
            return {...prevState, loading: false};
          });
        }
        else {
          CleanEmisionEjecucionCuenta();
          if (data.emisionEjecucionCuenta.id === 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, "No hay datos para mostrar");
          }
          setState(prevState => {
            return {...prevState, loading: false};
          });
        }

      })
      .catch((error) => {
          const message = 'Error procesando datos de cuenta: ' + error;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
          setState(prevState => {
            return {...prevState, loading: false};
          });
      });
  }

  //funciones
  function CleanEmisionEjecucionCuenta() {
    setResult(resultInit);
    formSet({...formValues,
      numero: 0,
      idCuenta: 0
    });
  }
  function FindEmisionEjecucionCuenta(idEmisionEjecucion, idEstadoEmisionEjecucionCuenta, numero, opType, idCuenta) {

    setState(prevState => {
      return {...prevState, loading: true};
    });

    const paramsUrl = (!isNull(numero)) ? `/numero/${idEmisionEjecucion}/${idEstadoEmisionEjecucionCuenta}/${numero}/${opType}` : `/cuenta/${idEmisionEjecucion}/${idCuenta}`;

    ServerRequest(
        REQUEST_METHOD.GET,
        null,
        true,
        APIS.URLS.EMISION_EJECUCION_CUENTA,
        paramsUrl,
        null,
        callbackSuccessFindEmisionEjecucionCuenta,
        callbackNoSuccess,
        callbackError
    );

  }

  function ExecuteEmisionEjecucionCuenta() {
    // props.onChange('ExecuteEmisionEjecucionCuenta', state.idCuenta);
  }


  function SetTabActive(tab) {
    setState(prevState => {
        return {...prevState, tabActive: tab};
    });
  }

  return (
  <>

    <Loading visible={state.loading}></Loading>

    {state.showMessage && 
        <MessageModal
            title={"Confirmación"}
            message={"¿Está seguro de volver a ejecutar la cuenta?"}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showMessage: false};
              });
            }}
            onConfirm={() => {
              setState(prevState => {
                  return {...prevState, showMessage: false};
              });
              ExecuteEmisionEjecucionCuenta();
            }}
        />
    }

    <div className='row'>

      <div className="col-12">

        <div className='row form-basic m-bottom-10 align-items-end'>
          {state.idCuenta === 0 &&
          <>
          <div className="col-6 col-md-4">
              <label htmlFor="numeroCuenta" className="form-label">Cuenta</label>
              <InputCuenta
                  name="idCuenta"
                  placeholder=""
                  className="form-control"
                  value={formValues.idCuenta}
                  idTipoTributo={state.idTipoTributo}
                  onChange={(event) => {
                      const {target} = event;
                      if (target.value > 0) {
                        const idCuenta = target.value;
                        FindEmisionEjecucionCuenta(state.emisionEjecucion.id, null, null, 0, idCuenta);
                      }
                      else {
                        CleanEmisionEjecucionCuenta();
                      }
                      formHandle(event);
                  }}
                  disabled={false}
              />
          </div>
          <div className="col-6 col-md-2">
              <label htmlFor="cuenta_idEstadoCuenta" className="form-label">Estado</label>
              <InputLista
                  name="idEstadoEmisionEjecucionCuenta"
                  placeholder=""
                  className="form-control"
                  value={formValues.idEstadoEmisionEjecucionCuenta}
                  onChange={formHandle}
                  disabled={false}
                  withItemZero={false}
                  lista="EstadoEmisionEjecucionCuenta"
              />
          </div>
          <div className="col-12 col-md-6">
            <button className="btn back-button no-m-horizontal m-left-10 float-end" data-dismiss="modal" onClick={ (event) => handleClickEmisionEjecucionCuentaNext() }>Siguiente</button>
            {(formValues.numero > 1) &&
            <button className="btn back-button no-m-horizontal float-end" data-dismiss="modal" onClick={ (event) => handleClickEmisionEjecucionCuentaPrevious() }>Anterior</button>
            }
          </div>
          </>
          }
          {result.emisionEjecucionCuenta.observacion.length > 0 &&
          <div className="col-12">
              <input
                  name="observacion"
                  type="text"
                  placeholder=""
                  maxLength={250}
                  className="form-control"
                  value={ result.emisionEjecucionCuenta.observacion }
                  disabled={true}
              />
          </div>
          }
        </div>
        
        <TableCustom
            showFilterGlobal={false}
            className={'TableCustomBase'}
            columns={tableColumnsCalculos.filter(f => state.emisionDefinicion.procesaRubros || f.id !== 'rubro')}
            data={result.emisionEjecucionCuenta.emisionCalculosResultado}
        />

      </div>
      <div className="col-12">

        <Tabs
            id="tabs-emision-ejecucion"
            activeKey={state.tabActive}
            className="m-top-20"
            onSelect={(tab) => SetTabActive(tab)}
        >
            <Tab eventKey="boleta_secciones" title="Boleta/Secciones" tabClassName={(state.emisionDefinicion.idBoletaDefinicion) ? '' : 'invisible'}>
                <div className='tab-panel'>

                    <TableCustom
                        showFilterGlobal={false}
                        className={'TableCustomBase'}
                        columns={tableColumnsBoletaSecciones.filter(f => state.emisionDefinicion.procesaRubros || f.id !== 'rubro')}
                        data={result.emisionEjecucionCuenta.emisionBoletaSeccionesResultado}
                    />

                </div>
            </Tab>
            <Tab eventKey="conceptos" title="Items/Conceptos">
                <div className='tab-panel'>

                    <TableCustom
                        showFilterGlobal={false}
                        className={'TableCustomBase'}
                        columns={tableColumnsConceptos.filter(f => state.emisionDefinicion.procesaRubros || f.id !== 'rubro')}
                        data={result.emisionEjecucionCuenta.emisionConceptosResultado}
                    />

                </div>
            </Tab>
            <Tab eventKey="ctacte" title="Cuenta corriente">
                <div className='tab-panel'>

                    <TableCustom
                        showFilterGlobal={false}
                        className={'TableCustomBase'}
                        columns={tableColumnsCuentasCorrientes.filter(f => state.emisionDefinicion.procesaRubros || f.id !== 'rubro')}
                        data={result.emisionEjecucionCuenta.emisionCuentasCorrientesResultado}
                    />

                </div>
            </Tab>
            <Tab eventKey="contabilidad" title="Imputación contable">
                <div className='tab-panel'>

                    <TableCustom
                        showFilterGlobal={false}
                        className={'TableCustomBase'}
                        columns={tableColumnsImputacionesContables.filter(f => state.emisionDefinicion.procesaRubros || f.id !== 'rubro')}
                        data={result.emisionEjecucionCuenta.emisionImputacionesContablesResultado}
                    />

                </div>
            </Tab>
        </Tabs>

      </div>

    </div>

  </>
  );
}

EmisionEjecucionCuentasGrid.propTypes = {
  disabled: bool,
  data: object.isRequired,
  onChange: func.isRequired
};

EmisionEjecucionCuentasGrid.defaultProps = {
  disabled: false
};

export default EmisionEjecucionCuentasGrid;